import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'home',
    meta: {
      authRequired: true,
      moduleName: 'Dashboard'
    },
    component: () => import('./views/dashboard/dashboard'),
  },

  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      authRequired: true,
      moduleName: 'Dashboard'
    },
    component: () => import('./views/dashboard/dashboard'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch('auth/logOut')
        } else {
          store.dispatch('authfack/logout')
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/login')
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },

   {
      path: '/test',
      name: 'test',
      meta: { 
        authRequired: true,
        moduleName: 'Tests'
      },
      component: () => import('./views/tests/view-tests')
   },

   {
      path: '/schedule',
      name: 'schedule',
      meta: { 
        authRequired: true,
        moduleName: 'Schedules'
      },
      component: () => import('./views/schedule/schedule')
   },

   {
      path: '/profile',
      name: 'profile',
      meta: { authRequired: true },
      component: () => import('./views/profile/profile')
   },

   {
      path: '/bookings',
      name: 'bookings',
      meta: { authRequired: true },
      component: () => import('./views/bookings/view-bookings')
   },

   
   {
      path: '/bookings/details/:id',
      name: 'bookings.details',
      meta: { authRequired: true },
      component: () => import('./views/bookings/bookings-details')
   },

   {
      path: '/bookings/add',
      name: 'bookings.add',
      meta: { authRequired: true },
      component: () => import('./views/bookings/add-booking')
   },

   {
      path: '/counters',
      name: 'counters',
      meta: { 
        authRequired: true,
        moduleName: 'Counters'
      },
      component: () => import('./views/counters/index.vue')
   },

   {
      path: '/outsource-token-calls',
      name: 'outsource.token.calls',
      meta: { 
        authRequired: true,
        moduleName: 'Outsource Token Calls'
      },
      component: () => import('./views/outsource-token-calls/index.vue')
   },

   {
      path: '/not-authorized',
      name: 'not-authorized',
      component: () => import('./views/NotAuthorized.vue'),
   },

   // {
   //    path: '/patients/records',
   //    name: 'patients.records',
   //    meta: { authRequired: true },
   //    component: () => import('./views/patients/records')
   // },

   // {
   //    path: '/patients/bookings',
   //    name: 'patients.bookings',
   //    meta: { authRequired: true },
   //    component: () => import('./views/patients/bookings')
   // },

   // {
   //    path: "/doctors/pending",
   //    name: "doctors.pending",
   //    meta: { authRequired: true },
   //    component: () => import('./views/doctors/pending-doctors')
   // },

   // {
   //    path: "/doctors/pending/details",
   //    name: "doctors.pending.details",
   //    meta: { authRequired: true },
   //    component: () => import('./views/doctors/pending-doctor-details')
   // },

   // {
   //    path: '/doctors',
   //    name: 'doctors',
   //    meta: { authRequired: true },
   //    component: () => import('./views/doctors/doctors')
   // },

   // {
   //    path: '/doctors/add',
   //    name: 'doctors.add',
   //    meta: { authRequired: true },
   //    component: () => import('./views/doctors/add-doctor')
   // },

   // {
   //    path: '/doctors/edit',
   //    name: 'doctors.edit',
   //    meta: { authRequired: true },
   //    component: () => import('./views/doctors/edit-doctor')
   // },

   // {
   //    path: '/doctors/details',
   //    name: 'doctors.details',
   //    meta: { authRequired: true },
   //    component: () => import('./views/doctors/doctor-details')
   // },

   //  {
   //    path: '/doctors/schedules',
   //    name: 'doctors.schedules',
   //    meta: { authRequired: true },
   //    component: () => import('./views/doctors/schedules')
   // },

   // {
   //    path: '/doctors/upcoming-schedules',
   //    name: 'doctors.upcoming',
   //    meta: { authRequired: true },
   //    component: () => import('./views/doctors/upcoming-schedules')
   // },

   // {
   //    path: '/doctors/payments',
   //    name: 'doctors.payments',
   //    meta: { authRequired: true },
   //    component: () => import('./views/doctors/payments')
   // },

   // {
   //    path: '/doctors/payments/details',
   //    name: 'doctors.payments.details',
   //    meta: { authRequired: true },
   //    component: () => import('./views/doctors/payment-details')
   // },

   // {
   //    path: '/doctors/bookings',
   //    name: 'doctors.bookings',
   //    meta: { authRequired: true },
   //    component: () => import('./views/doctors/bookings')
   // },

   // {
   //    path: '/consultations',
   //    name: 'consultations',
   //    meta: { authRequired: true },
   //    component: () => import('./views/consultations/consultations')
   // },

   // {
   //    path: '/consultations/add',
   //    name: 'consultations.add',
   //    meta: { authRequired: true },
   //    component: () => import('./views/consultations/add-consultation')
   // }, 

   // {
   //    path: '/consultations/details',
   //    name: 'consultations.details',
   //    meta: { authRequired: true },
   //    component: () => import('./views/consultations/consultation-details')
   // }, 

   // {
   //    path: "/pharmacy-orders",
   //    name: "pharmacy.orders",
   //    meta: { authRequired: true },
   //    component: () => import('./views/pharmacy/orders')
   // },

   // {
   //    path: "/pharmacy-orders/add",
   //    name: "pharmacy.orders.add",
   //    meta: { authRequired: true },
   //    component: () => import('./views/pharmacy/create-order')
   // },

   // {
   //    path: "/pharmacy-orders/reorder",
   //    name: "pharmacy.orders.reorder",
   //    meta: { authRequired: true },
   //    component: () => import('./views/pharmacy/reorder')
   // },

   // {
   //    path: "/pharmacy-orders/details",
   //    name: "pharmacy.orders.details",
   //    meta: { authRequired: true },
   //    component: () => import('./views/pharmacy/order-details')
   // },

   // {
   //    path: "/pharmacy-requests",
   //    name: "pharmacy.requests",
   //    meta: { authRequired: true },
   //    component: () => import('./views/pharmacy/requests')
   // },

   // {
   //    path: "/pharmacy-requests/details",
   //    name: "pharmacy.requests.details",
   //    meta: { authRequired: true },
   //    component: () => import('./views/pharmacy/request-details')
   // },

   // {
   //    path: '/languages',
   //    name: 'languages',
   //    meta: { authRequired: true },
   //    component: () => import('./views/languages/languages')
   // },

   // {
   //    path: '/sliders',
   //    name: 'sliders',
   //    meta: { authRequired: true },
   //    component: () => import('./views/sliders/sliders')
   // },

   // {
   //    path: '/coupons',
   //    name: 'coupons',
   //    meta: { authRequired: true },
   //    component: () => import('./views/coupons/coupons')
   // },

   // {
   //    path: '/delivery-staffs',
   //    name: 'deliverystaffs',
   //    meta: { authRequired: true },
   //    component: () => import('./views/delivery-staffs/delivery-staffs')
   // },

   // {
   //    path: '/delivery-staffs/add',
   //    name: 'deliverystaffs.add',
   //    meta: { authRequired: true },
   //    component: () => import('./views/delivery-staffs/add-delivery-staff')
   // },

   // {
   //    path: '/delivery-staffs/edit',
   //    name: 'deliverystaffs.edit',
   //    meta: { authRequired: true },
   //    component: () => import('./views/delivery-staffs/edit-delivery-staff')
   // },

   // {
   //    path: '/delivery-staffs/details',
   //    name: 'deliverystaffs.details',
   //    meta: { authRequired: true },
   //    component: () => import('./views/delivery-staffs/delivery-staff-details')
   // },


   // {
   //    path: '/marketing-staffs',
   //    name: 'marketingstaffs',
   //    meta: { authRequired: true },
   //    component: () => import('./views/marketing-staffs/marketing-staffs')
   // },

   // {
   //    path: '/marketing-staffs/add',
   //    name: 'marketingstaffs.add',
   //    meta: { authRequired: true },
   //    component: () => import('./views/marketing-staffs/add-marketing-staff')
   // },

   // {
   //    path: '/marketing-staffs/edit',
   //    name: 'marketingstaffs.edit',
   //    meta: { authRequired: true },
   //    component: () => import('./views/marketing-staffs/edit-marketing-staff')
   // },

   // {
   //    path: '/marketing-staffs/details',
   //    name: 'marketingstaffs.details',
   //    meta: { authRequired: true },
   //    component: () => import('./views/marketing-staffs/marketing-staff-details')
   // },

   // {
   //    path: '/marketing-staffs/referrals',
   //    name: 'marketingstaffs.referrals',
   //    meta: { authRequired: true },
   //    component: () => import('./views/marketing-staffs/referrals')
   // },

   // {
   //    path: '/clinics',
   //    name: 'clinics',
   //    meta: { authRequired: true },
   //    component: () => import('./views/clinics/clinics')
   // },

   // {
   //    path: '/clinics/add',
   //    name: 'clinics.add',
   //    meta: { authRequired: true },
   //    component: () => import('./views/clinics/add-clinic')
   // },

   // {
   //    path: '/clinics/edit',
   //    name: 'clinics.edit',
   //    meta: { authRequired: true },
   //    component: () => import('./views/clinics/edit-clinic')
   // },

   // {
   //    path: '/clinics/doctors',
   //    name: 'clinics.doctors',
   //    meta: { authRequired: true },
   //    component: () => import('./views/clinics/doctors')
   // },

   // {
   //    path: '/tvshows',
   //    name: 'tvshows',
   //    meta: { authRequired: true },
   //    component: () => import('./views/tvshows/tvshows')
   // },

   // {
   //    path: '/feedbacks',
   //    name: 'feedbacks',
   //    meta: { authRequired: true },
   //    component: () => import('./views/feedbacks/feedbacks')
   // },

   // {
   //    path: '/scroll-contents',
   //    name: 'scrollcontents',
   //    meta: { authRequired: true },
   //    component: () => import('./views/scrolling-contents/scrolling-contents')
   // },


   // {
   //    path: '/faqs',
   //    name: 'faqs',
   //    meta: { authRequired: true },
   //    component: () => import('./views/faqs/faqs')
   // },

   // {
   //    path: '/notifications',
   //    name: 'notifications',
   //    meta: { authRequired: true },
   //    component: () => import('./views/notifications/notifications')
   // },


   // {
   //    path: '/settings',
   //    name: 'settings',
   //    meta: { authRequired: true },
   //    component: () => import('./views/settings/settings')
   // },
  
]
